import { Box, Container, Grid, Slider, Table, TableFooter } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledTable = styled(Table)(({ theme }) => ({
  "& thead": {
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: theme.palette.background.default
  },
  "& .MuiTableCell-head": {
    cursor: "pointer"
  },
  "& .MuiSvgIcon-root": {
    opacity: "0",
    fontSize: "18px",
    transition:
      "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    marginLeft: "4px",
    userSelect: "none",
    marginRight: "4px"
  },
  "& .MuiTableSortLabel-active svg, .MuiSvgIcon-root": {
    color: theme.palette.primary.dark,
    opacity: "1"
  },
  "& tbody tr": {
    "&:hover": {
      background: theme.palette.info.light
    },
    "& .MuiTableCell-root": {
      maxWidth: "300px",
      [theme.breakpoints.down("xl")]: {
        maxWidth: "100%"
      }
    },
    "&.expanded": {
      "& .MuiTable-root": {
        paddingTop: "8px"
      },
      "&:hover": {
        background: theme.palette.info.light
      },
      "& .MuiTableCell-root": {
        borderTop: "1px solid rgba(224, 224, 224, 1)",
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
        paddingLeft: "16px"
      },
      "& .MuiTableCell-root:last-child": {
        borderRight: "1px solid rgba(224, 224, 224, 1)"
      },
      "& .MuiTableCell-root:first-child": {
        color: "red !important",
        borderLeft: "1px solid rgba(224, 224, 224, 1)"
      },
      background: theme.palette.foreground.default,
      border: "none",
      "&  th": {
        background: theme.palette.grey[200]
      },
      "& > td": {
        paddingTop: "0 !important"
      },
      "& td": {
        background: theme.palette.foreground.default,
        padding: "8px"
      }
    }
  },
  [theme.breakpoints.down("xl")]: {
    border: 0,

    "& thead": {
      display: "none",
      border: "none",
      clip: "rect(0 0 0 0)",
      height: "1px",
      margin: "-1px",
      padding: 0,
      position: "absolute",
      width: "1px"
    },

    "& tr": {
      borderBottom: "3px solid #ddd",
      display: "block",
      marginBottom: " .625em"
    },

    "& td": {
      borderBottom: "1px solid #ddd",
      display: "block",
      fontSize: " .8em",
      textAlign: "right",
      minHeight: "29px"
    },

    "& td::before": {
      content: "attr(data-label)",
      float: "left",
      fontWeight: "bold",
      textTransform: "uppercase"
    },

    "& td:last-child": {
      borderBottom: 0
    }
  }
}))
export const StyledTableFooter = styled(TableFooter)({
  backgroundColor: "rgba(239, 239, 239, 1)",
  borderTop: "2px solid rgba(224, 224, 224, 1)",
  zIndex: 100,
  "& td": {
    fontWeight: 700,
    color: "rgba(0, 0, 0, 0.87)",
    border: 0
  }
})

export const StyledGrid = styled(Grid)({
  display: "flex",
  gap: "20px"
})

export const StyledBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  overflowX: "auto"
}))

export const StyledFilterContainer = styled(Container)(({ theme }) => ({
  paddingTop: "24px",
  paddingBottom: "24px"
}))

export const StyledSpan = styled("span")({
  display: "flex",
  alignItems: "center"
})

export const StyledFlexRender = styled("span")(({ theme }) => ({
  "& p": {
    fontSize: "0.875rem",
    LineHeight: "1.43",
    textAlign: "left",
    [theme.breakpoints.down("xl")]: {
      textAlign: "right"
    }
  }
}))

export const StyledSliderWrapper = styled(Box)({
  width: "100%",
  minWidth: "250px"
})

export const StyledSlider = styled(Slider)(({ theme, isPhone }) => ({
  width: "100%",
  color: theme.palette.primary[700],
  marginBottom: isPhone ? "20px" : "0",
  "& .MuiSlider-track": {
    height: "2px"
  }
}))
